import { Sparkles } from 'lucide-react'
import { cn } from '@/lib/utils'

type Props = {
    label?: string
    showAvatar?: boolean
}

export default function ThinkingIndicator({ label = 'Thinking', showAvatar = false }: Props) {
    return (
        <div className={cn('flex items-center gap-3', !showAvatar && 'gap-0')}>
            {showAvatar && (
                <div className='flex h-7 w-7 shrink-0 items-center justify-center rounded-lg bg-primary-main/10'>
                    <Sparkles className='h-3.5 w-3.5 text-primary-main' />
                </div>
            )}
            <div className='relative inline-block overflow-hidden'>
                <span className='shimmer-text text-sm font-medium'>{label}</span>
            </div>
            <style>
                {`
                    @keyframes shimmer-slide {
                        0% { background-position: -200% center; }
                        100% { background-position: 200% center; }
                    }
                    .shimmer-text {
                        background: linear-gradient(
                            90deg,
                            #94a3b8 0%,
                            #94a3b8 30%,
                            #1e293b 50%,
                            #94a3b8 70%,
                            #94a3b8 100%
                        );
                        background-size: 200% auto;
                        background-clip: text;
                        -webkit-background-clip: text;
                        color: transparent;
                        -webkit-text-fill-color: transparent;
                        animation: shimmer-slide 2s linear infinite;
                    }
                `}
            </style>
        </div>
    )
}
